/**
 * A space's small square mark: its initial on its colour. Its own module so
 * light surfaces (Recents rows) can draw it without pulling in
 * Home's sidebar and its popovers.
 *
 * @module components/spaces/SpaceGlyph
 */
import { cn } from "~/lib/utils";
import { SPACE_COLOR_CLASS, spaceInitial, type Space } from "../../state/spaces";

/** A space's small square mark: its initial on its colour. */
export function SpaceGlyph({ space, className }: { readonly space: Space; readonly className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-flex size-4 shrink-0 items-center justify-center rounded-[4px] text-[9px] font-semibold leading-none",
        SPACE_COLOR_CLASS[space.color],
        className,
      )}
    >
      {spaceInitial(space.name)}
    </span>
  );
}
